import { EKycDocumentVerificationStatus, EKycVerificationStatus } from '@exam-center/graphql';
import { ColorPalette } from '@shared/components';

export const EKYC_DOCUMENT_STATUS_TEXT = {
  [EKycDocumentVerificationStatus.NotStarted]: 'ยังไม่ได้ตรวจสอบ',
  [EKycDocumentVerificationStatus.Rejected]: 'ไม่สำเร็จ',
  [EKycDocumentVerificationStatus.Verified]: 'สำเร็จ',
  [EKycDocumentVerificationStatus.Invalid]: 'TBD',
  [EKycDocumentVerificationStatus.Uploaded]: 'TBD',
  [EKycDocumentVerificationStatus.Expired]: 'หมดอายุแล้ว',
};

export const EKYC_DOCUMENT_STATUS_COLOR = {
  [EKycDocumentVerificationStatus.NotStarted]: ColorPalette.SECONDARY,
  [EKycDocumentVerificationStatus.Rejected]: ColorPalette.ERROR,
  [EKycDocumentVerificationStatus.Verified]: ColorPalette.SUCCESS,
};

export const EKYC_APPROVAL_STATUS_TEXT = {
  [EKycVerificationStatus.PendingApproval]: 'ยังไม่ได้ตรวจสอบ',
  [EKycVerificationStatus.Rejected]: 'ไม่สำเร็จ',
  [EKycVerificationStatus.Approved]: 'สำเร็จ',
};

export const EKYC_APPROVAL_STATUS_COLOR = {
  [EKycVerificationStatus.Approved]: ColorPalette.SUCCESS,
  [EKycVerificationStatus.PendingApproval]: ColorPalette.SECONDARY,
  [EKycVerificationStatus.Rejected]: ColorPalette.ERROR,
};

export const ACCESSIBLE_EKYC_STATUSES: EKycVerificationStatus[] = [
  EKycVerificationStatus.PendingApproval,
  EKycVerificationStatus.Rejected,
  EKycVerificationStatus.Approved,
];
